import {useState, useEffect} from 'react';
import {sendGetRequest} from '../api/requests';
import {DEFAULT_ERROR} from '../api/constants';

const useFetch = (apiUrl: string, dependencies?: unknown, params?: object) => {
  const [isLoading, setLoading] = useState(true);
  const [data, setData] = useState<any>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    setLoading(true);
    (async () => {
      try {
        const response = await sendGetRequest(apiUrl, params);
        setData(response);
      } catch (error) {
        setError(error?.message || DEFAULT_ERROR);
      } finally {
        setLoading(false);
      }
    })();
    return () => {
      setLoading(false);
      setError('');
    };
  }, [apiUrl, JSON.stringify(dependencies)]);

  return [data, isLoading, error];
};

export default useFetch;
